// extracted by mini-css-extract-plugin
export default {"notebox":"notebox_notebox__WPnsO"};